var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu-row", attrs: { id: "top" } },
    [
      _vm._l(_vm.menu, function(m, k) {
        return _c(
          "div",
          { key: k, staticClass: "menu-item" },
          [
            !m.url
              ? _c("link-to", { attrs: { to: m.link } }, [
                  _vm._v(_vm._s(m.name))
                ])
              : _vm._e(),
            m.url
              ? _c("a", { attrs: { href: m.url, target: "_blank" } }, [
                  _vm._v(_vm._s(m.name))
                ])
              : _vm._e()
          ],
          1
        )
      }),
      _c("div", { staticClass: "menu-item--right" }, [
        _c(
          "a",
          {
            class: {
              "menu-item--button": true,
              hovered: _vm.entranceDesktopHovered
            },
            attrs: { href: "https://online.russoutdoor.ru/", target: "_blank" }
          },
          [_vm._v("Вход")]
        ),
        _c("span", { staticClass: "menu-item--text" }, [
          _vm._v(_vm._s(_vm.toppromo.description))
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-df24ad54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df24ad54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/header/Menu.vue
// module id = Vpyw
// module chunks = 41